import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "size-full flex flex-col overflow-y-scroll scroll-smooth no-scrollbar" };
const _hoisted_2 = { class: "flex-shrink-0 pt-3 pb-4" };
const _hoisted_3 = { class: "flex flex-wrap gap-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "font-medium" };
const _hoisted_6 = { class: "flex-1 pt-4" };
const _hoisted_7 = { class: "space-y-4" };
const _hoisted_8 = { class: "relative" };
const _hoisted_9 = { class: "relative" };
import { ref, watch } from 'vue';
import { X } from 'lucide-vue-next';
import { useHomeFilterStore } from './homeFilterStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-price',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const priceRanges = [
            { label: '1 - 200,000', min: 1, max: 200000 },
            { label: '200,001 - 400,000', min: 200001, max: 400000 },
            { label: '400,001 - 600,000', min: 400001, max: 600000 },
            { label: '600,001 - 800,000', min: 600001, max: 800000 },
            { label: '800,001 - 1,000,000', min: 800001, max: 1000000 },
        ];
        const minPriceInput = ref(homeFilterStore.minPrice || '');
        const maxPriceInput = ref(homeFilterStore.maxPrice || '');
        // Watch for changes in store values to update inputs
        watch(() => homeFilterStore.minPrice, (newVal) => {
            minPriceInput.value = newVal || '';
        });
        watch(() => homeFilterStore.maxPrice, (newVal) => {
            maxPriceInput.value = newVal || '';
        });
        const isRangeSelected = (range) => {
            return homeFilterStore.minPrice === range.min && homeFilterStore.maxPrice === range.max;
        };
        const selectPriceRange = (range) => {
            homeFilterStore.minPrice = range.min;
            homeFilterStore.maxPrice = range.max;
            minPriceInput.value = range.min;
            maxPriceInput.value = range.max;
        };
        const updateMinPrice = () => {
            const value = Number(minPriceInput.value);
            homeFilterStore.minPrice = !isNaN(value) && value > 0 ? value : 0;
        };
        const updateMaxPrice = () => {
            const value = Number(maxPriceInput.value);
            homeFilterStore.maxPrice = !isNaN(value) && value > 0 ? value : 0;
        };
        const clearMinPrice = () => {
            minPriceInput.value = '';
            homeFilterStore.minPrice = 0;
        };
        const clearMaxPrice = () => {
            maxPriceInput.value = '';
            homeFilterStore.maxPrice = 0;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priceRanges, (range) => {
                            return _createElementVNode("button", {
                                key: range.label,
                                onClick: ($event) => (selectPriceRange(range)),
                                class: _normalizeClass([
                                    'w-auto px-2 py-1 text-left rounded-lg border transition-all',
                                    isRangeSelected(range)
                                        ? 'bg-primary2 border-primary2 text-white'
                                        : 'bg-white border-badge/30 text-badge hover:border-primary2 hover:bg-primary2/5'
                                ])
                            }, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(range.label), 1)
                            ], 10, _hoisted_4);
                        }), 64))
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Minimum Price", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((minPriceInput).value = $event)),
                                    type: "number",
                                    placeholder: "0",
                                    min: "0",
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMinPrice
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        minPriceInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (minPriceInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: clearMinPrice,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear minimum price"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Maximum Price", -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((maxPriceInput).value = $event)),
                                    type: "number",
                                    placeholder: "No limit",
                                    min: "0",
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMaxPrice
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        maxPriceInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (maxPriceInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: clearMaxPrice,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear maximum price"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
